/* ============================================================================
   IHN BLOGS — CONSTANTS & MOCK DATA
   All category lists and mock blog data for the Blogs page live here.
   Swap BLOG_POSTS for a real API response later without touching UI code.
   ============================================================================ */

export const CATEGORIES = [
  "Blogs",
  "Food",
  "Travel",
  "Business",
  "Lifestyle",
  "Fashion",
  "Technology",
  "General",
  "Published",
];

export const BLOG_POSTS = [
  {
    id: 1,
    title: "This Wisconsin Couple Lives in a Yurt, and Winter Is Their Favorite Part",
    category: "Travel",
    excerpt:
      "How two former city dwellers traded square footage for snowfall, and why the coldest months became the reason they stayed.",
    content:
      "When Elaina and her husband first pitched the idea of moving into a yurt on eleven wooded acres, most of their friends assumed it was a phase. Two winters later, it has become the opposite of a phase — it is the way they intend to keep living. The couple spent their first year insulating, building a sleeping loft, and learning the particular choreography of keeping a wood stove fed through a Wisconsin cold snap. What surprised them most wasn't the hardship, it was how much lighter their days felt once the space around them stopped asking for upkeep it didn't need. Their mornings now start with hauling water and end with the stove ticking as it cools, a rhythm neither of them expected to miss on the rare nights they stay in town.",
    author: "Editorial Team",
    company: "IHN Editorial",
    publisher: "IHN Editorial",
    date: "June 2, 2026",
    likes: 412,
    comments: 96,
    images: [
      "https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: true,
  },
  {
    id: 2,
    title: "The Weirdest Best Part of Trips Is Never the Part You Planned",
    category: "Travel",
    excerpt:
      "A case for leaving one afternoon of every itinerary completely, deliberately empty.",
    content:
      "Ask any well-travelled guest what they remember most from a trip and it is rarely the reservation they waited months for. It's the wrong turn that led to a courtyard concert, the hotel concierge who insisted on a detour, the rainstorm that closed the museum and opened a three-hour lunch instead. Our editorial team spoke with a dozen frequent travelers about the moments that stuck, and the pattern was almost embarrassingly consistent: the trips people talk about years later are the ones with room left in them. We've started building that room into every itinerary we recommend — one unscheduled afternoon, no agenda attached.",
    author: "Priya Nair",
    company: "IHN India",
    publisher: "IHN Editorial",
    date: "August 14, 2026",
    likes: 268,
    comments: 71,
    images: [
      "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 3,
    title: "Inside the Hotels Bringing Back the Art of the Welcome Drink",
    category: "Travel",
    excerpt:
      "A small gesture at check-in is quietly becoming the signature of a great stay.",
    content:
      "There was a period when the welcome drink felt like a relic — something hotels offered because a brand manual said to, not because anyone particularly wanted it. That's changed. Properties from mountain lodges to city towers are treating the first sip a guest takes as an actual introduction to the place: a bitter aperitif in the Dolomites, a cold-brewed hibiscus in coastal towns, a spiced tea poured tableside rather than handed over a counter. The shift tracks with a broader move in hospitality toward specificity over polish. Guests remember the drink that tasted like somewhere. They forget the one that tasted like nowhere in particular.",
    author: "Marcus Webb",
    company: "IHN Business",
    publisher: "IHN Editorial",
    date: "March 3, 2026",
    likes: 189,
    comments: 34,
    images: [
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 4,
    title: "My 10 Favorite Trader Joe's Products, Ranked Without Apology",
    category: "Food",
    excerpt:
      "A completely biased, thoroughly researched list of what's actually worth the cart space.",
    content:
      "Every few months our editorial team revisits this list, and every few months it changes less than we expect. Some products simply hold their position — the kind of reliable that makes a weeknight easier without asking for credit. This round adds two newcomers and quietly retires an old favorite that, if we're honest, we'd stopped actually buying. Ranking groceries is a low-stakes exercise and we intend to keep treating it that way, but there is something satisfying about being specific about the small things that make a kitchen work.",
    author: "Jenna Ostrander",
    company: "IHN Lifestyle",
    publisher: "IHN Editorial",
    date: "July 22, 2026",
    likes: 356,
    comments: 118,
    images: [
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: true,
  },
  {
    id: 5,
    title: "What a Tasting Menu Teaches You About Pacing a Meal",
    category: "Food",
    excerpt:
      "Chefs are rethinking course order to slow diners down, one small plate at a time.",
    content:
      "The best tasting menus we've sat through this year weren't the ones with the most ambitious ingredients — they were the ones that understood rhythm. A kitchen that opens loud and stays loud exhausts a table by course six. The ones getting it right open quiet, build in waves, and leave one deliberately plain course in the middle to reset the palate before the finale. It's a lesson that scales down surprisingly well to a home dinner party: sequence matters more than any single dish.",
    author: "Editorial Team",
    company: "IHN Editorial",
    publisher: "IHN Editorial",
    date: "May 9, 2026",
    likes: 142,
    comments: 27,
    images: [
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 6,
    title: "The Neighborhood Bakery That Only Sells Out on Tuesdays",
    category: "Food",
    excerpt:
      "Why a single weekly batch has become the most reliable reservation in town.",
    content:
      "There's no sign, no online ordering, and no explanation for why Tuesday is the day — the baker simply decided it years ago and never revisited the choice. What's built up around that one arbitrary decision is a small, devoted ritual: regulars who plan their morning route around it, a line that forms before opening, and a rye loaf that sells out within the hour every single week. It's a reminder that consistency, not novelty, is usually what turns a good product into a habit.",
    author: "Priya Nair",
    company: "IHN India",
    publisher: "IHN Editorial",
    date: "February 18, 2026",
    likes: 97,
    comments: 19,
    images: [
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 7,
    title: "The #1 Thing Not to Say in a Job Interview, and More Reader Questions",
    category: "Business",
    excerpt:
      "Our editorial team answers the workplace questions readers keep sending in.",
    content:
      "This week's mailbag leans heavily on interviews and negotiation, so we're devoting the column to both. The most common mistake we see isn't a bad answer to a hard question — it's over-explaining a simple one until it sounds like an apology. Confidence in an interview is mostly a matter of stopping at the right moment. We also cover how to ask about compensation without flinching, and when it's appropriate to follow up a second time after a quiet inbox.",
    author: "Marcus Webb",
    company: "IHN Business",
    publisher: "IHN Editorial",
    date: "September 1, 2026",
    likes: 231,
    comments: 84,
    images: [
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: true,
  },
  {
    id: 8,
    title: "Why Small Teams Are Quietly Outperforming Large Ones This Year",
    category: "Business",
    excerpt:
      "A look at the operational habits behind lean teams shipping faster than their size suggests.",
    content:
      "Talk to enough founders this year and a pattern emerges: the teams moving fastest are often the smallest ones in the room, not the best-funded. What they share isn't a growth hack — it's a refusal to add a meeting, a role, or a process until the pain of not having it is undeniable. That discipline is unglamorous and hard to sustain past a certain headcount, which may be exactly why it works as long as it does.",
    author: "Editorial Team",
    company: "IHN Editorial",
    publisher: "IHN Editorial",
    date: "April 27, 2026",
    likes: 154,
    comments: 41,
    images: [
      "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 9,
    title: "21 Completely Subjective Rules for Raising Teenage Boys",
    category: "Lifestyle",
    excerpt:
      "A running list of household rules that have earned their place through trial and error.",
    content:
      "Some of these rules are practical — shoes off, phones out of the bedroom by ten. Others are harder to justify on paper but have proven their worth in the moment, like the family policy that no serious conversation happens in a moving car unless someone is driving. None of this is prescriptive; it's simply what has held up in one household over several years, offered in case any of it is useful in another.",
    author: "Jenna Ostrander",
    company: "IHN Lifestyle",
    publisher: "IHN Editorial",
    date: "June 30, 2026",
    likes: 298,
    comments: 103,
    images: [
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 10,
    title: "What Do You Love About the Way You Look?",
    category: "Fashion",
    excerpt:
      "We asked readers to describe one feature they've stopped apologizing for.",
    content:
      "It started as a single question sent out to our newsletter list and turned into one of the largest reader threads we've run. The answers were unexpectedly specific — a jawline someone spent years wishing away, hands that look exactly like a grandmother's, a laugh line that shows up in every photo since 2019. Taken together, the responses read less like a beauty feature and more like a quiet, collective exhale.",
    author: "Priya Nair",
    company: "IHN India",
    publisher: "IHN Editorial",
    date: "July 5, 2026",
    likes: 331,
    comments: 129,
    images: [
      "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: true,
  },
  {
    id: 11,
    title: "The Return of Tailoring: Why Fit Is Beating Trend This Season",
    category: "Fashion",
    excerpt:
      "A well-cut plain jacket is quietly outselling the season's loudest pieces.",
    content:
      "Fashion cycles fast, but tailoring has a way of resurfacing every time trend fatigue sets in. This season's version isn't formal in the old sense — it's a single well-cut piece worn with something deliberately casual underneath, the contrast doing more work than any single statement item could. Several stylists we spoke with credit the shift to a simple realization among their clients: clothes that fit properly photograph and feel better than clothes that merely follow a trend.",
    author: "Marcus Webb",
    company: "IHN Business",
    publisher: "IHN Editorial",
    date: "January 21, 2026",
    likes: 88,
    comments: 22,
    images: [
      "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 12,
    title: "Backstage at a Small-City Fashion Week That's Outgrowing Its Venue",
    category: "Fashion",
    excerpt:
      "A regional show is drawing a national audience, one careful season at a time.",
    content:
      "Three years ago the show ran out of a converted warehouse with folding chairs and a borrowed sound system. This year it sold out a proper venue in eleven minutes. What hasn't changed is the organizers' insistence on keeping the guest list local first — press and buyers are welcome, but the front row still seats the same handful of longtime supporters it always has. That loyalty, more than any single collection, seems to be what's pulling attention from further afield.",
    author: "Editorial Team",
    company: "IHN Editorial",
    publisher: "IHN Editorial",
    date: "August 29, 2026",
    likes: 176,
    comments: 45,
    images: [
      "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 13,
    title: "Inside a Conference That Banned Panels and Nobody Missed Them",
    category: "Business",
    excerpt:
      "A two-day event replaced every panel discussion with structured small-group conversation.",
    content:
      "The organizers expected pushback when they announced the format change six months out. Instead, registrations went up. What they built instead of the usual panel track was a rotation of small, moderated tables — eight people, thirty minutes, one specific question — repeated across the two days. Attendees left with names and follow-ups rather than notes from a stage they could have watched online. It's a small format change with an obvious lesson: most people didn't come for the panel, they came for the room.",
    author: "Priya Nair",
    company: "IHN India",
    publisher: "IHN Editorial",
    date: "March 30, 2026",
    likes: 121,
    comments: 38,
    images: [
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 14,
    title: "The Quiet Return of the Desktop Computer",
    category: "Technology",
    excerpt:
      "After a decade of going portable, a growing number of people are building a desk they don't carry anywhere.",
    content:
      "It sounds like a step backward until you talk to the people doing it. For a specific kind of focused work, a machine that stays in one place — paired with a proper monitor, a keyboard that isn't optimized for a backpack, and no notifications following you to the couch — is proving to be less about nostalgia and more about drawing a hard line between work and everywhere else. The laptop isn't going anywhere, but it's losing its monopoly on where serious work happens.",
    author: "Marcus Webb",
    company: "IHN Business",
    publisher: "IHN Editorial",
    date: "September 8, 2026",
    likes: 204,
    comments: 52,
    images: [
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 15,
    title: "How One Small Team Automated Their Busiest Week of the Year",
    category: "Technology",
    excerpt:
      "A retail operations team traded a four-day scramble for a two-hour review.",
    content:
      "The task wasn't glamorous — reconciling seasonal inventory across a dozen spreadsheets — but it used to consume the better part of a week every quarter. The team's fix wasn't a new platform, it was a narrow, well-scoped script that handled exactly one repetitive step and nothing else. That restraint is the part worth noting: the temptation to build a sweeping system is usually a mistake when a small, boring tool solves the actual problem.",
    author: "Editorial Team",
    company: "IHN Editorial",
    publisher: "IHN Editorial",
    date: "May 16, 2026",
    likes: 133,
    comments: 29,
    images: [
      "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 16,
    title: "A Reading List for People Who Say They Don't Have Time to Read",
    category: "General",
    excerpt:
      "Short books, real ones, chosen for the version of you that reads in ten-minute windows.",
    content:
      "The premise here is simple: the obstacle usually isn't interest, it's the assumption that reading requires an uninterrupted evening. Every title on this list can be finished in a week of commute-length sittings, and none of them are padded to hit a page count. Consider it a low-commitment way back into a habit that tends to disappear quietly and return the same way.",
    author: "Jenna Ostrander",
    company: "IHN Lifestyle",
    publisher: "IHN Editorial",
    date: "February 4, 2026",
    likes: 112,
    comments: 24,
    images: [
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 17,
    title: "What Twenty Years of Keeping a Notebook Has Actually Taught Me",
    category: "General",
    excerpt:
      "A long-running habit, revisited honestly, warts and all.",
    content:
      "Two decades of notebooks sound like they should add up to some grand conclusion, and mostly they don't. What they do offer is a strange kind of evidence — proof that most worries from any given year turn out to be forgotten within two. That alone has made the habit worth keeping, even on the years when the notebook itself barely gets used.",
    author: "Priya Nair",
    company: "IHN India",
    publisher: "IHN Editorial",
    date: "January 9, 2026",
    likes: 64,
    comments: 15,
    images: [
      "https://images.unsplash.com/photo-1517322048670-4fba75cbbb62?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 18,
    title: "The Case for Doing One Thing Badly on Purpose",
    category: "General",
    excerpt:
      "A small argument for keeping at least one hobby you have no intention of getting good at.",
    content:
      "Somewhere along the way, hobbies started needing a point — a skill to show for the hours, a small business, a following. This is a case for resisting that instinct at least once: pick something you're genuinely bad at, stay bad at it on purpose, and notice how much lighter that one hour of your week becomes once nothing is riding on it.",
    author: "Marcus Webb",
    company: "IHN Business",
    publisher: "IHN Editorial",
    date: "August 2, 2026",
    likes: 187,
    comments: 48,
    images: [
      "https://images.unsplash.com/photo-1476231682828-37e571bc172f?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: true,
  },
  {
    id: 19,
    title: "The Hotel Restaurants Locals Actually Book On Purpose",
    category: "Food",
    excerpt:
      "A handful of hotel dining rooms have stopped feeling like an afterthought for guests only.",
    content:
      "Hotel restaurants have historically had a reputation problem — safe, overpriced, built for a captive audience rather than a discerning one. That's shifting at a small number of properties willing to hire a kitchen team with its own point of view and let it run somewhat independently of the rest of the operation. The result is a short but growing list of hotel dining rooms that locals book on their own, with no room key required.",
    author: "Editorial Team",
    company: "IHN Editorial",
    publisher: "IHN Editorial",
    date: "September 5, 2026",
    likes: 145,
    comments: 33,
    images: [
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
  {
    id: 20,
    title: "Where the First Snow Actually Falls Each Year, Mapped",
    category: "Travel",
    excerpt:
      "A look back at last winter's earliest snowfall, and what it means for planning the next one.",
    content:
      "We pulled a year of weather data to trace exactly where winter tends to arrive first, and the results shift some long-held assumptions about which regions to plan around for an early-season trip. It's a reminder that the most useful travel guidance is often the least glamorous: not where to go, but when to actually go there.",
    author: "Jenna Ostrander",
    company: "IHN Lifestyle",
    publisher: "IHN Editorial",
    date: "January 3, 2026",
    likes: 79,
    comments: 12,
    images: [
      "https://images.unsplash.com/photo-1493246507139-91e8fad9978e?auto=format&fit=crop&w=1200&q=80",
    ],
    isEditorsPick: false,
  },
];
/* ============================================================================
   CATEGORY LISTING CONSTANTS (merged from BlogsCategoryConst)
   ============================================================================ */
export const BRAND_PURPLE = "#861b68";
export const BRAND_PURPLE_DARK = "#590040";
export const INK = "#000000";
export const MUTED = "#6b6b6b";
/* ------------------------------------------------------------
   MOCK DATA — 63+ blog posts, 9+ per category
   ------------------------------------------------------------ */
export const BLOGS = [
  // ---------------- FOOD (9) ----------------
  {
    id: 1,
    title: "The Small Restaurant Worth Crossing the City For",
    category: "Food",
    isEditorsPickBadge: true,
    isExpertVoice: true,
    excerpt: "A family-run kitchen in Old Delhi that has quietly outcooked every trend around it for thirty years.",
    content: "Tucked behind a spice market in Old Delhi, this restaurant has never advertised and never needed to. The menu hasn't changed since 1994, and that's exactly the point. Walking through the narrow entrance, you are greeted by the aroma of slow-cooked gravies perfected over three decades.\n\nThe family runs every station — the son now handles the tandoor while his mother still prepares the chutneys herself. Regulars know to arrive before the evening rush, because once the limited seats fill, the wait stretches into something unhurried but inevitable.\n\nThe simplicity of the space is part of the charm — no music, no décor tricks, just food that speaks clearly. What keeps people coming back is the consistency: a dal that tastes exactly like it did the first time, a bread that arrives at the table with the same blistered edges year after year.\n\nIn a city obsessed with the next opening, this place is a quiet reminder that longevity is its own kind of excellence. Some restaurants don't need reinventing — they need protecting.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 9, 2026",
    likes: 512,
    comments: 38,
    images: [
      "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: true,
  },
  {
    id: 2,
    title: "What I Learned From Cooking With a Five-Star Chef",
    category: "Food",
    excerpt: "A week in a Michelin kitchen taught me more about patience than about technique.",
    content: "The chef barely raised his voice all week. Precision, I realized, isn't about pressure — it's about repetition done so many times it becomes instinct. Watching him work was like watching someone speak a language they'd been fluent in since childhood.\n\nEvery movement had purpose: the way he tested a sauce with the back of a spoon, the angle at which he placed herbs on a plate, the deliberate pause before seasoning. He taught me that the difference between good food and exceptional food is rarely a dramatic gesture.\n\nIt is the accumulation of tiny decisions — a pinch less salt, a few seconds more heat, a plate wiped clean before it leaves the pass. The kitchen brigade moved in quiet coordination, no shouting, no chaos.\n\nThat calm wasn't accidental. It came from preparation so thorough that execution felt effortless. On the third morning, the sous-chef walked me through the mise en place — every component weighed, labeled and positioned before service began.\n\nBy the end of the week, I understood that technique is just the starting point. The real skill is patience — the willingness to do the same thing a hundred times until the hundred-and-first time looks effortless.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 6, 2026",
    likes: 384,
    comments: 24,
    images: [
      "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1556909212-d5b604d0c90d?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1482049016688-2d3e1b311543?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 3,
    title: "My Favorite Places to Eat in Delhi",
    category: "Food",
    excerpt: "A personal, unranked list built over a decade of eating in the same neighborhoods.",
    content: "No influencer recommendations here — just the dhabas and diners I keep returning to, and why each one earned its place. Delhi's food landscape changes fast, but certain spots hold their ground through sheer consistency.\n\nThere is a chaat stall in Chandni Chowk that has been frying kachoris since before I was born, and the flavor hasn't shifted an inch. In Defence Colony, a small café serves what I consider the best sourdough in the city, baked fresh each morning by an owner who learned the craft in Melbourne and brought it home.\n\nFurther south, a family-run restaurant in Saket does a thali that captures the breadth of Rajasthani home cooking without diluting it for a metropolitan palate. What connects these places isn't cuisine or price — it's intention.\n\nEach one does a narrow thing very well and has no interest in doing anything else. That focus is increasingly rare in a dining culture that rewards novelty over depth.\n\nThe real lesson of a decade of eating in Delhi is that the best meals are rarely the most photographed ones. They're the ones served with the kind of confidence that comes from having nothing to prove.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 2, 2026",
    likes: 301,
    comments: 24,
    images: [
      "https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1596797038530-2c107229654b?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 4,
    title: "The Ingredient Every Indian Kitchen Underrates",
    category: "Food",
    excerpt: "It's not saffron or ghee — it's the humble curry leaf, and it deserves more credit.",
    content: "A short case for the ingredient that quietly makes or breaks a dish, from South Indian tempering to modern fusion plates.",
    author: "Meera Kapoor",
    company: "Hyatt Regency",
    publisher: "IHN",
    date: "August 29, 2026",
    likes: 142,
    comments: 19,
    images: ["https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 5,
    title: "How Street Food Vendors Are Building Real Businesses",
    category: "Food",
    excerpt: "Behind the carts and stalls are small enterprises with surprisingly sharp economics.",
    content: "We spoke to five vendors about margins, supply chains and the informal networks that keep the country's best food affordable.",
    author: "Rohan Sethi",
    company: "Hilton India",
    publisher: "IHN",
    date: "August 24, 2026",
    likes: 448,
    comments: 31,
    images: ["https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 6,
    title: "A Weekend of Home Cooking, Slowed Down",
    category: "Food",
    excerpt: "What happens when you cook without a timer, a recipe, or a reason to rush.",
    content: "Three dishes, two days, no shortcuts. A reflection on why slow cooking still matters in a fast kitchen culture.",
    author: "Ishita Rao",
    company: "Radisson Blu",
    publisher: "IHN",
    date: "August 19, 2026",
    likes: 158,
    comments: 22,
    images: ["https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 7,
    title: "The Regional Breakfasts India Doesn't Talk About Enough",
    category: "Food",
    excerpt: "Beyond idli and paratha, a look at the morning meals that rarely leave their home states.",
    content: "A tour through lesser-known breakfasts — from Assam's pitha to Goa's poi — and the mornings built around them.",
    author: "Arjun Malhotra",
    company: "Taj Hotels",
    publisher: "IHN",
    date: "August 14, 2026",
    likes: 133,
    comments: 17,
    images: ["https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 8,
    title: "Why Everyone Suddenly Cares About Where Their Coffee Comes From",
    category: "Food",
    excerpt: "India's specialty coffee scene is growing up fast, and the farmers are finally part of the conversation.",
    content: "From Coorg estates to city roasteries, a look at how traceability became the industry's biggest selling point.",
    author: "IHN Editorial",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "August 9, 2026",
    likes: 121,
    comments: 15,
    images: ["https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 9,
    title: "The Dinner Party Menu That Never Fails",
    category: "Food",
    excerpt: "Four dishes, minimal last-minute work, and a plan that leaves you actually enjoying your own party.",
    content: "A tested menu built for hosts who want an impressive table without spending the evening in the kitchen.",
    author: "Ishita Rao",
    company: "Radisson Blu",
    publisher: "IHN",
    date: "August 3, 2026",
    likes: 165,
    comments: 20,
    images: ["https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },

  // ---------------- TRAVEL (9) ----------------
  {
    id: 10,
    title: "The Quiet Coastal Town I Want to Return To",
    category: "Travel",
    isExpertVoice: true,
    isEditorsPickBadge: true,
    isTrending: true,
    excerpt: "No major attractions, no crowds — just a fishing town on the Konkan coast that stayed with me.",
    content: "Sometimes the best trips are the ones with nothing planned. A few days in Gokarna reminded me why. The town sits where the Western Ghats meet the Arabian Sea, and the landscape carries a kind of quiet confidence that doesn't need to impress anyone.\n\nMornings started with a walk to the beach, where fishermen were already hauling in the night's catch. Afternoons were spent in hammocks strung between coconut palms, with nothing more demanding than a book and a breeze.\n\nThe food was uncomplicated — fresh fish, rice, and the kind of curry that tastes like someone's grandmother spent all morning on it. There were no souvenirs worth buying, no Instagram spots to chase.\n\nWhat Gokarna offered instead was space — physical and mental — to simply exist without a plan. By the third day, I stopped checking my phone entirely.\n\nThat kind of disconnection doesn't happen in curated resort experiences. It happens in places that haven't yet learned to perform for visitors.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 8, 2026",
    likes: 492,
    comments: 41,
    images: [
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: true,
  },
  {
    id: 11,
    title: "A Weekend Guide to India's Most Charming Heritage Hotels",
    category: "Travel",
    isTrending: true,
    excerpt: "Converted havelis and forts that turn a stay into the reason for the trip.",
    content: "From Rajasthan to Kerala, a shortlist of heritage properties worth building an itinerary around. India's heritage hotels aren't just places to sleep — they are the trip itself.\n\nIn Jaipur, a restored 18th-century haveli keeps its original courtyard at the center of the experience, with each room decorated to reflect a different era of Rajasthani craft. Further north, a fort-turned-hotel in Jodhpur offers panoramic views from battlements that once defended a kingdom.\n\nIn Kerala, a converted Dutch mansion on the Fort Kochi waterfront serves breakfast on a veranda that overlooks centuries-old fishing nets. What these properties share is a commitment to authenticity over luxury.\n\nThe walls show their age, the furniture tells a story, and the staff often comes from families who have lived in the area for generations. Staying in one shifts the purpose of travel from sightseeing to immersion.\n\nYou don't visit these places; you inhabit them, even if only for a weekend. The best part is the evenings — the courtyards come alive with conversations that no itinerary could have planned.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 4, 2026",
    likes: 428,
    comments: 27,
    images: [
      "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 12,
    title: "How to Do the Himalayas Without a Fixed Itinerary",
    category: "Travel",
    excerpt: "A loose framework for travelers who want structure without losing the spontaneity.",
    content: "Base yourself, move slowly, and let the mountains set the pace — practical notes from three weeks in Himachal. The Himalayas don't reward urgency. The traveler who tries to cover too much ground in too little time ends up seeing roads instead of landscapes.\n\nThe better approach is to choose a base — a small town like Tirthan Valley, Chitkul, or Bir — and explore outward from there in loose, day-long arcs. Mornings are for walking trails that don't appear on any map.\n\nAfternoons belong to the chai stalls where locals gather and conversations happen at the speed of the landscape. Evenings come early in the mountains, and the best response is to let them.\n\nWhat I learned from three weeks of slow travel is that the Himalayas reveal themselves to those who wait. A mountain you passed yesterday looks entirely different in today's light. A trail that seemed unremarkable on the way up becomes extraordinary on the way down.\n\nThe freedom of having no fixed itinerary isn't about being spontaneous — it's about being present enough to notice what's actually there.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "August 30, 2026",
    likes: 172,
    comments: 23,
    images: [
      "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1454496522488-7a8e488e8606?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1493246507139-91e8fad9978e?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 13,
    title: "The Islands Off India's Coast Worth Planning Around",
    category: "Travel",
    excerpt: "Beyond the well-known beaches, a look at the archipelagos that reward a slightly longer flight.",
    content: "The Andamans, Lakshadweep and a few lesser-visited islands, compared for divers, families and quiet-seekers alike.",
    author: "Rhea Mathur",
    company: "JW Marriott",
    publisher: "IHN",
    date: "August 25, 2026",
    likes: 156,
    comments: 18,
    images: ["https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 14,
    title: "What Traveling Alone Taught Me About Traveling With Others",
    category: "Travel",
    excerpt: "A solo trip changed how I plan every group trip since.",
    content: "Notes on pacing, decision-making, and the small compromises that make shared travel actually enjoyable.",
    author: "Karan Vij",
    company: "Marriott India",
    publisher: "IHN",
    date: "August 20, 2026",
    likes: 140,
    comments: 16,
    images: ["https://images.unsplash.com/photo-1533105079780-92b9be482077?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 15,
    title: "The Hill Stations That Still Feel Undiscovered",
    category: "Travel",
    excerpt: "A handful of towns that haven't yet made it onto the standard summer list.",
    content: "Cooler, quieter, and considerably less crowded than the usual hill-station names — for now.",
    author: "Rhea Mathur",
    company: "JW Marriott",
    publisher: "IHN",
    date: "August 15, 2026",
    likes: 128,
    comments: 14,
    images: ["https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 16,
    title: "A Practical Guide to Slow Travel in South India",
    category: "Travel",
    excerpt: "Trains over flights, towns over checklists — a case for a different kind of itinerary.",
    content: "Three weeks, four states, and a deliberate refusal to rush from one landmark to the next.",
    author: "Naina Chopra",
    company: "Novotel Delhi",
    publisher: "IHN",
    date: "August 10, 2026",
    likes: 149,
    comments: 21,
    images: ["https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 17,
    title: "The Desert Camps Redefining Rajasthan Tourism",
    category: "Travel",
    excerpt: "Beyond the postcard shots, a new generation of camps built around sustainability and craft.",
    content: "Local materials, local staff, and an experience designed to outlast the trend of luxury desert glamping.",
    author: "Karan Vij",
    company: "Marriott India",
    publisher: "IHN",
    date: "August 5, 2026",
    likes: 134,
    comments: 12,
    images: ["https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 18,
    title: "Where to Watch the Monsoon Roll In",
    category: "Travel",
    excerpt: "A few places where the rains are the main event, not an inconvenience.",
    content: "From Munnar's tea slopes to the Western Ghats, destinations best experienced in the wettest months of the year.",
    author: "Rhea Mathur",
    company: "JW Marriott",
    publisher: "IHN",
    date: "July 31, 2026",
    likes: 118,
    comments: 10,
    images: ["https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },

  // ---------------- BUSINESS (9) ----------------
  {
    id: 19,
    title: "What Great Hospitality Businesses Do Differently",
    category: "Business",
    excerpt: "It isn't the amenities — it's how decisions get made when no guest is watching.",
    content: "A look at three operators who built reputations on consistency, not spectacle, and what that costs them. Walk into a truly great hotel and you won't see the machinery behind it — but you'll feel it.\n\nThe front desk that remembered your name from a booking six months ago. The housekeeping team that anticipates rather than responds. None of this is magic; it's decision-making.\n\nWhile weaker operators chase one-off gestures — a grand lobby, a celebrity chef — the best hospitality businesses obsess over the hundred small routines a guest experiences in a single day. They train staff to notice without being asked, and they measure success in repeat visits rather than one-time wow.\n\nThat discipline is expensive in attention but cheap in spectacle, and it shows. In interviews, the operators behind these properties rarely talk about amenities. They talk about standards — a housekeeping checklist reviewed daily, a pre-shift briefing that happens even on slow Tuesdays.\n\nConsistency, they know, compounds quietly into the kind of reputation that no marketing budget can buy.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 9, 2026",
    likes: 412,
    comments: 33,
    images: [
      "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: true,
  },
  {
    id: 20,
    title: "The Leadership Habit That Changes a Team",
    category: "Business",
    isEditorsPickBadge: true,
    excerpt: "It's smaller than most leadership advice, and it's the one habit that actually compounds.",
    content: "Ask better questions before giving better answers — a simple shift with outsized effect on team output. Most leadership training focuses on how leaders communicate downward: clearer briefs, sharper feedback, more inspiring talks.\n\nBut the habit that quietly separates productive teams from stagnant ones is the opposite direction — how leaders ask. A leader who responds to every problem with an answer trains their team to stop thinking and start waiting.\n\nA leader who responds with questions — what do you see, what's the constraint, what have you tried — builds a team that solves problems before they ever reach the top. I watched this play out across two teams doing identical work.\n\nThe first had a manager who solved everything; the second had a manager who asked everything. Within a year, the second team was shipping faster, and its members were visibly more confident.\n\nAsking doesn't come naturally to people promoted for their answers. But it's a habit, not a personality. You practice it in daily stand-ups, in one-on-ones, in every request that reaches your desk. The compound effect is the difference between a team that executes and a team that decides.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 5, 2026",
    likes: 348,
    comments: 29,
    images: [
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 21,
    title: "How Family Businesses in India Are Professionalizing",
    category: "Business",
    isTrending: true,
    excerpt: "A generational shift is quietly reshaping how legacy companies operate.",
    content: "Second and third generation leaders are bringing structure to businesses built on instinct — not without friction. The transition is rarely smooth. The founder built the business on relationships and gut calls; the next generation wants dashboards and documented processes.\n\nThat tension between instinct and infrastructure defines the professionalization journey of India's family businesses. Some of the sharpest examples come from hospitality, where a small resort chain decided to hand day-to-day operations to an external CEO while the family retained ownership and culture.\n\nOthers have split the difference — keeping the founder as chairman while formalizing boards, audited accounts, and clear succession plans. What makes it work is neither abandoning tradition nor redoing everything at once.\n\nThe families that succeed professionalize in layers: hiring finance before marketing, installing systems where money moves before touching the parts of the culture that give the business its identity.\n\nThe result is a company that keeps the founder's DNA but can survive without the founder in the room. That, ultimately, is the point — a family business that lives longer than any single generation's decisions.",
    author: "Rahul Mehta",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 1, 2026",
    likes: 296,
    comments: 25,
    images: [
      "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 22,
    title: "Why Community Matters More Than Capital in Early Growth",
    category: "Business",
    excerpt: "The businesses that scale fastest often start with a network, not a fundraise.",
    content: "A case for building relationships before building a pitch deck, drawn from founders who did it that way.",
    author: "Sana Iqbal",
    company: "Sheraton Grand",
    publisher: "IHN",
    date: "August 27, 2026",
    likes: 146,
    comments: 19,
    images: ["https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
    isTrending: true,
  },
  {
    id: 23,
    title: "The Real Cost of Growing Too Fast",
    category: "Business",
    excerpt: "Three founders on the decisions they'd unwind if they could go back.",
    content: "Honest reflections on scaling ahead of demand, culture, and cash — and what recovery actually looked like.",
    author: "Priya Nair",
    company: "IHN India",
    publisher: "IHN",
    date: "August 22, 2026",
    likes: 132,
    comments: 17,
    images: ["https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: true,
    isEditorsPickBadge: true,
    isExpertVoice: true,
  },
  {
    id: 24,
    title: "What Negotiators Get Wrong About Winning",
    category: "Business",
    excerpt: "The best outcome isn't always the one where you got the most.",
    content: "A veteran dealmaker on why durable agreements beat one-sided ones, especially in repeat relationships.",
    author: "Vikram Anand",
    company: "Vivanta Hotels",
    publisher: "IHN",
    date: "August 17, 2026",
    likes: 124,
    comments: 15,
    images: ["https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 25,
    title: "Inside the Rise of India's Regional Business Hubs",
    category: "Business",
    excerpt: "Growth is no longer concentrated in the usual metro cities.",
    content: "Tier-2 cities are attracting talent and capital on their own terms — here's what's driving the shift.",
    author: "Sana Iqbal",
    company: "Sheraton Grand",
    publisher: "IHN",
    date: "August 12, 2026",
    likes: 138,
    comments: 20,
    images: ["https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 26,
    title: "The Case for Slower, More Deliberate Hiring",
    category: "Business",
    excerpt: "Fast hiring feels efficient right up until it isn't.",
    content: "A founder's account of rebuilding a hiring process around fit and clarity instead of speed.",
    author: "Priya Nair",
    company: "IHN India",
    publisher: "IHN",
    date: "August 7, 2026",
    likes: 396,
    comments: 35,
    images: ["https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: true,
    isEditorsPickBadge: true,
    isExpertVoice: true,
    isTrending: true,
  },
  {
    id: 27,
    title: "How Trust Became India's Most Underrated Business Asset",
    category: "Business",
    excerpt: "In tightly networked communities, reputation moves faster than contracts.",
    content: "A look at how community-based trade still runs on relationships first, paperwork second.",
    author: "Sana Iqbal",
    company: "Sheraton Grand",
    publisher: "IHN",
    date: "August 2, 2026",
    likes: 109,
    comments: 11,
    images: ["https://images.unsplash.com/photo-1573164713988-8665fc963095?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },

  // ---------------- LIFESTYLE (9) ----------------
  {
    id: 28,
    title: "The Small Rituals That Make Busy Weeks Feel Better",
    category: "Lifestyle",
    excerpt: "None of these take more than ten minutes, and all of them change the shape of a week.",
    content: "A short list of low-effort habits — a walk without a phone, a proper lunch break — worth protecting. When a week becomes a blur of meetings and deadlines, the smallest structures often matter most.\n\nA ten-minute morning stretch before checking any screen sets a calmer tone than an hour of half-focused scrolling from bed. A walk around the block at lunch, done deliberately without a phone, breaks the day into two halves instead of letting it collapse into one long stretch of cognition.\n\nEven the evening matters — closing the laptop with a firm action instead of trailing off into another tab. None of these rituals require discipline in the grand sense. They require deciding, in a calm moment, that certain small corners of the day are protected.\n\nWhat surprised me is how quickly the trivial-feeling ones became non-negotiable. Now the walk without a phone isn't something I make time for; it's the thing that makes the rest of the day rearrangeable.\n\nThe week still gets busy. It just no longer gets to feel endless.",
    author: "Ananya Bose",
    company: "Grand Hyatt Mumbai",
    publisher: "IHN",
    date: "September 8, 2026",
    likes: 364,
    comments: 26,
    images: [
      "https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: true,
  },
  {
    id: 29,
    title: "How to Create a More Relaxed Morning",
    category: "Lifestyle",
    excerpt: "It's less about waking up earlier and more about starting with fewer decisions.",
    content: "A simple framework for mornings that don't start with a scramble — built around preparation the night before. The most relaxed mornings have a secret: nothing begins in the morning.\n\nClothes are chosen the night before. Lunch is packed while dinner dishes are still on the counter. The first decision of the day isn't what to wear or what to eat — it's simply whether to stand up now or in ten more minutes.\n\nWe tested this across a few weeks and the shift was immediate. Removing two or three choices from the start of the day doesn't sound like much, but it changes the feeling of the entire morning. The brain treats a cascade of small decisions as friction, and friction reads as stress.\n\nWhen the morning routine is largely pre-decided, that stress has nowhere to come from. The other half of the framework is lowering the ask: a relaxed morning doesn't require a sunrise routine or a cold plunge.\n\nIt requires a cup of tea taken while sitting down, a kitchen that wasn't left in chaos, and the honest refusal to look at work until after breakfast. Much of what we call morning chaos is just the previous night's unfinished business arriving late.",
    author: "Ishaan Verma",
    company: "Leela Palaces",
    publisher: "IHN",
    date: "September 3, 2026",
    likes: 154,
    comments: 21,
    images: [
      "https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1520209759809-a9bcb6cb3241?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 30,
    title: "What a Year Without Social Media Actually Looked Like",
    category: "Lifestyle",
    excerpt: "Less about willpower, more about what filled the space that opened up.",
    content: "An honest account of the boredom, the clarity, and the eventual return — on different terms. I deleted every app on January 1st, expecting a dramatic transformation.\n\nThe first two weeks were mostly boredom — the kind of restless discomfort you don't realize you've been medicating with thumb movement. The third week is when something shifted. The urge to reach for a phone during dead time slowly faded, replaced by the mildly startling habit of just sitting with a thought.\n\nBy month three, I'd read more books than in the previous three years and had started cooking meals that required actual attention. The clarity everyone talks about is real, but it's quieter than advertised.\n\nIt's not a revelation; it's a background hum of calm that you stop noticing until it's gone. The return, when it happened, was deliberate. I reinstalled two apps with strict time limits and no notifications.\n\nThe difference is that social media is now a tool I use, not a room I live in. I'm not a convert, and I won't lecture anyone. I just know the year taught me something with an empty schedule that a full one never could.",
    author: "Ananya Bose",
    company: "Grand Hyatt Mumbai",
    publisher: "IHN",
    date: "August 28, 2026",
    likes: 300,
    comments: 24,
    images: [
      "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1519638399535-1b036603ac77?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 31,
    title: "Building a Home That Feels Like a Rest",
    category: "Lifestyle",
    excerpt: "A few practical changes made a small apartment feel noticeably calmer.",
    content: "Less about design trends, more about removing friction — fewer things, better light, clearer surfaces.",
    author: "Divya Malhotra",
    company: "ITC Hotels",
    publisher: "IHN",
    date: "August 23, 2026",
    likes: 141,
    comments: 18,
    images: ["https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 32,
    title: "The Friendships That Take Effort to Keep",
    category: "Lifestyle",
    excerpt: "Some friendships thrive on convenience. The best ones survive without it.",
    content: "On staying close to people across cities, time zones and busy years — and why it's always worth the effort.",
    author: "Ishaan Verma",
    company: "Leela Palaces",
    publisher: "IHN",
    date: "August 18, 2026",
    likes: 236,
    comments: 22,
    images: ["https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 33,
    title: "How Journaling Changed the Way I Make Decisions",
    category: "Lifestyle",
    excerpt: "Not for productivity — for slowing down enough to actually think.",
    content: "Two years of writing every morning taught me more about my own patterns than any advice ever did.",
    author: "Divya Malhotra",
    company: "ITC Hotels",
    publisher: "IHN",
    date: "August 13, 2026",
    likes: 129,
    comments: 15,
    images: ["https://images.unsplash.com/photo-1517841905240-472988babdf9?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 34,
    title: "Why Doing Nothing Is Harder Than It Sounds",
    category: "Lifestyle",
    excerpt: "Unstructured time makes most of us uncomfortable — that discomfort is worth sitting with.",
    content: "A reflection on rest as a skill, not a reward, and why we're so bad at practicing it.",
    author: "Ananya Bose",
    company: "Grand Hyatt Mumbai",
    publisher: "IHN",
    date: "August 8, 2026",
    likes: 117,
    comments: 13,
    images: ["https://images.unsplash.com/photo-1531306728370-e2ebd9d7bb99?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 35,
    title: "The Weekly Habit That Keeps Big Goals Alive",
    category: "Lifestyle",
    excerpt: "A short check-in, done consistently, beats an ambitious plan revisited once a year.",
    content: "How a ten-minute Sunday review kept a long list of goals from quietly disappearing.",
    author: "Ishaan Verma",
    company: "Leela Palaces",
    publisher: "IHN",
    date: "August 3, 2026",
    likes: 108,
    comments: 12,
    images: ["https://images.unsplash.com/photo-1519925610903-381054cc2a1c?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 36,
    title: "Learning to Say No Without the Guilt",
    category: "Lifestyle",
    excerpt: "It gets easier — but only once you understand what you're actually protecting.",
    content: "Practical language and a shift in mindset for setting boundaries that stick, at work and outside it.",
    author: "Divya Malhotra",
    company: "ITC Hotels",
    publisher: "IHN",
    date: "July 29, 2026",
    likes: 122,
    comments: 14,
    images: ["https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },

  // ---------------- FASHION (9) ----------------
  {
    id: 37,
    title: "The New Rules of Effortless Dressing",
    category: "Fashion",
    isEditorsPickBadge: true,
    excerpt: "Fewer pieces, better fabrics, and a wardrobe that stops asking questions every morning.",
    content: "A practical look at building a capsule wardrobe around Indian fabrics and modern silhouettes. Effortless dressing is rarely about style — it's about removal.\n\nThe women and men who look put-together without appearing to try are working from a small set of pieces that fit well, photograph well, and combine without disagreement. The first rule is fabric. In India's climate, natural fibers — cotton, linen, silk, khadi — do more work than any cut.\n\nThey breathe, they drape, and they look expensive in a way that polyester never does. The second rule is color restraint. A wardrobe built on a base of neutrals — ivory, sand, charcoal, deep green — makes the mornings easy and lets one accent piece carry an entire outfit.\n\nThe third rule is silhouette over trend. A well-cut kurta or a sharp trouser worn with deliberate plainness outlasts whatever is currently loud.\n\nWhat every effortless dresser has quietly figured out is that the goal isn't to look prepared. It's to look unbothered — and you can't fake that with a closet full of decisions you have to make at 8 a.m.",
    author: "Tara Sen",
    company: "Pullman Gurgaon",
    publisher: "IHN",
    date: "September 7, 2026",
    likes: 456,
    comments: 13,
    images: [
      "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1445205170230-053b83016050?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: true,
  },
  {
    id: 38,
    title: "How Indian Designers Are Redefining Modern Style",
    category: "Fashion",
    isExpertVoice: true,
    excerpt: "A new generation is treating heritage craft as a starting point, not a constraint.",
    content: "From handloom revivals to genderless tailoring, five designers pushing Indian fashion in new directions. Indian fashion is having a quiet revolution, and it's not happening on the runways you'd expect.\n\nA new generation of designers is taking craft that used to be considered traditional and placing it in entirely modern contexts — a bandhgala cut from Japanese denim, a handloom sari styled like a gown, men's tailoring reimagined with embroidery that once lived only on bridal wear.\n\nThe through-line is respect without reverence: these designers aren't reproducing heritage, they're in conversation with it. The market's response has been decisive. Young consumers who once looked abroad for their fashion vocabulary are buying Indian design that doesn't apologize for being Indian.\n\nStores in Delhi and Mumbai report that the same pieces sell out and waitlist, something inconceivable a decade ago.\n\nWhat makes this generation different is confidence. They don't need to prove the craft is worthy — it already was. They're simply asking what it becomes next, and the answer is a fashion scene that finally looks like the country it's made in.",
    author: "Devika Rao",
    company: "The Oberoi Group",
    publisher: "IHN",
    date: "September 2, 2026",
    likes: 392,
    comments: 28,
    images: [
      "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1516762689617-e1cffcef479d?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 39,
    title: "The Case for Buying Fewer, Better Clothes",
    category: "Fashion",
    excerpt: "A year of buying almost nothing taught me what actually earns a place in a wardrobe.",
    content: "On slowing down consumption without giving up on personal style — and what changed in the process. For twelve months, I committed to buying almost nothing new.\n\nThe experiment wasn't about moral purity; it was about observing my own relationship with buying. What became clear almost immediately is how much shopping had been a substitute for thinking — a way of feeling like I was moving toward a version of myself without actually defining it.\n\nWith the option removed, I was forced to work with what I had, and what I had turned out to be more than enough. Repairs got made instead of replacements purchased. Two old shirts got tailored into one that fits properly.\n\nThe gaps in my wardrobe, it turned out, were mostly in my imagination. By month six, I'd developed a test: if I can't think of three ways to wear a piece, I don't need it.\n\nThe experiment didn't turn me into a minimalist. It gave me a much clearer idea of what belongs in a wardrobe — which is the difference between clothes that are worn and clothes that are stored.",
    author: "Tara Sen",
    company: "Pullman Gurgaon",
    publisher: "IHN",
    date: "August 28, 2026",
    likes: 167,
    comments: 21,
    images: [
      "https://images.unsplash.com/photo-1445205170230-053b83016050?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1490114538077-0a7f8cb49891?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1523609045329-c41b36322749?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1487222477894-8943e31ef7b2?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 40,
    title: "Inside the Revival of Handloom Weaving",
    category: "Fashion",
    excerpt: "A younger market is rediscovering handloom — and weavers are finally being paid for it.",
    content: "How direct-to-consumer brands are reshaping the economics of a centuries-old craft.",
    author: "Devika Rao",
    company: "The Oberoi Group",
    publisher: "IHN",
    date: "August 23, 2026",
    likes: 152,
    comments: 19,
    images: ["https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 41,
    title: "What Actually Makes an Outfit Look Expensive",
    category: "Fashion",
    excerpt: "It's rarely the price tag — it's fit, fabric and restraint.",
    content: "A breakdown of the small choices that separate a polished outfit from an expensive-looking mistake.",
    author: "Tara Sen",
    company: "Pullman Gurgaon",
    publisher: "IHN",
    date: "August 18, 2026",
    likes: 328,
    comments: 23,
    images: ["https://images.unsplash.com/photo-1490114538077-0a7f8cb49891?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 42,
    title: "The Accessories Worth the Investment",
    category: "Fashion",
    excerpt: "A short list of pieces that outlast every trend around them.",
    content: "From a well-made leather bag to a single good watch — items chosen for longevity, not novelty.",
    author: "Devika Rao",
    company: "The Oberoi Group",
    publisher: "IHN",
    date: "August 13, 2026",
    likes: 139,
    comments: 16,
    images: ["https://images.unsplash.com/photo-1509631179647-0177331693ae?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 43,
    title: "How Wedding Fashion in India Is Changing",
    category: "Fashion",
    excerpt: "Lighter fabrics, smaller guest lists, and a shift away from maximalism.",
    content: "Designers and brides on why celebration fashion is quietly becoming more personal and less prescribed.",
    author: "Tara Sen",
    company: "Pullman Gurgaon",
    publisher: "IHN",
    date: "August 8, 2026",
    likes: 148,
    comments: 20,
    images: ["https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 44,
    title: "The Return of Tailoring in Everyday Wardrobes",
    category: "Fashion",
    excerpt: "Structured pieces are finding their way back into casual rotation.",
    content: "Why a well-cut jacket or trouser is replacing loungewear as the new comfortable default.",
    author: "Devika Rao",
    company: "The Oberoi Group",
    publisher: "IHN",
    date: "August 3, 2026",
    likes: 126,
    comments: 14,
    images: ["https://images.unsplash.com/photo-1516762689617-e1cffcef479d?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 45,
    title: "Dressing for the Climate, Not Just the Calendar",
    category: "Fashion",
    excerpt: "India's fashion seasons rarely match its weather — a case for dressing by climate instead.",
    content: "Practical notes on building a wardrobe suited to heat, humidity and monsoon, without sacrificing style.",
    author: "Tara Sen",
    company: "Pullman Gurgaon",
    publisher: "IHN",
    date: "July 29, 2026",
    likes: 118,
    comments: 11,
    images: ["https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },

  // ---------------- TECHNOLOGY (9) ----------------
  {
    id: 46,
    title: "How AI Is Changing the Hospitality Industry",
    category: "Technology",
    excerpt: "From front-desk automation to predictive staffing, the shift is bigger than chatbots.",
    content: "A look at how hotels and resorts are quietly rebuilding operations around AI-assisted decision-making. Ask most people about AI in hotels and they picture a chatbot answering booking questions at 2 a.m. The reality is more interesting and more invisible.\n\nBehind the scenes, revenue managers are using AI to price rooms in real time, balancing occupancy, seasonality and competitor rates against demand signals that change by the hour. Housekeeping schedules are being generated algorithmically, matching guest preferences — early risers, late checkouts — to when rooms actually get cleaned.\n\nPredictive maintenance tools flag a failing AC unit before a guest complains about it. The common denominator is that none of this replaces people; it replaces guesswork.\n\nFront-desk staff spend their time on guests who need attention, not on re-typing reservations. Managers see forecasts instead of post-mortems.\n\nThe hotels getting the most value are the ones treating AI as a quiet layer of infrastructure rather than a demo worth boasting about. The shift is less dramatic than science fiction promised, and far more useful.",
    author: "Nikhil Bhatia",
    company: "Park Hyatt",
    publisher: "IHN",
    date: "September 9, 2026",
    likes: 448,
    comments: 34,
    images: [
      "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1526378722484-bd91ca387e72?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: true,
  },
  {
    id: 47,
    title: "The Technology Behind a Smarter Guest Experience",
    category: "Technology",
    isExpertVoice: true,
    isTrending: true,
    isEditorsPick: true,
    isEditorsPickBadge: true,
    excerpt: "Personalization is now infrastructure, not a feature.",
    content: "How property management systems are learning guest preferences well before check-in. The moment a guest books, the smartest hotels are already working.\n\nProperty management systems now ingest years of preference data — the floor a guest prefers, the firmness of pillows they've requested before, the hours they tend to be in the room, even how they like their coffee. All of this is stitched into the reservation before the front desk ever sees the booking.\n\nThis is personalization as infrastructure: invisible, continuous, and utterly unglamorous. The visible part is small — a cooler room on a warm night, the right newspaper at the door, a late checkout the guest never had to ask for.\n\nWhat matters is that none of it relies on a heroic staff member remembering a regular's habits. The system remembers. For boutique properties with a dozen rooms, the same logic applies at human scale; for large city hotels, the technology is the only way to make a five-hundred-room property feel like it knows you.\n\nThe privacy questions are real and worth watching. But the direction is unambiguous: the personalized stay is no longer a luxury gesture. It's just how the industry runs now.",
    author: "Simran Kaur",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "September 4, 2026",
    likes: 384,
    comments: 27,
    images: [
      "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 48,
    title: "Why Community Platforms Are the Next Business Infrastructure",
    category: "Technology",
    isTrending: true,
    excerpt: "Networks built around trust are becoming as important as the tools businesses use.",
    content: "A look at how digital communities are quietly replacing cold outreach as the primary channel for growth. For a decade, growth strategy meant one thing: getting in front of as many strangers as possible. Ads, cold emails, outbound funnels — volume in, hope out.\n\nThat model is quietly exhausting itself. People no longer trust strangers with their attention, and that has made community the most interesting piece of business infrastructure being built right now.\n\nA well-run community platform — a members' forum, a private group, a niche network — concentrates exactly the audience a business needs, pre-warmed by shared identity. Instead of shouting into the street, a business walks into a room where the trust already exists and simply behaves well.\n\nWe watched hotels launch guest communities that outperform their email lists, and founders build customer networks that function as focus groups, support desks and referral engines simultaneously.\n\nThe infrastructure is still primitive — most platforms are barely more than structured conversation — but that's precisely the opportunity. The businesses that treat community as core plumbing, not a marketing afterthought, are building advantages that will be very hard to replicate once everyone else wakes up to it.",
    author: "Nikhil Bhatia",
    company: "Park Hyatt",
    publisher: "IHN",
    date: "August 30, 2026",
    likes: 320,
    comments: 22,
    images: [
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1516387938699-a93567ec168e?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 49,
    title: "The Rise of Voice-First Interfaces in Everyday Apps",
    category: "Technology",
    excerpt: "Typing is quietly becoming optional across the apps people use daily.",
    content: "Why voice input is moving from novelty to default, and what that means for how products get designed.",
    author: "Simran Kaur",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "August 25, 2026",
    likes: 145,
    comments: 18,
    images: ["https://images.unsplash.com/photo-1512446816042-444d641267d4?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 50,
    title: "How Small Businesses Are Using Automation Without a Tech Team",
    category: "Technology",
    excerpt: "No-code tools are letting small operators run like much larger ones.",
    content: "Real examples of independent businesses automating billing, scheduling and outreach without hiring developers.",
    author: "Nikhil Bhatia",
    company: "Park Hyatt",
    publisher: "IHN",
    date: "August 20, 2026",
    likes: 137,
    comments: 16,
    images: ["https://images.unsplash.com/photo-1526378722484-bd91ca387e72?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 51,
    title: "The Quiet Rise of Privacy-First Products",
    category: "Technology",
    excerpt: "A growing set of users are choosing products specifically because of what they don't collect.",
    content: "Why privacy is shifting from a compliance checkbox to an actual product differentiator.",
    author: "Simran Kaur",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "August 15, 2026",
    likes: 128,
    comments: 14,
    images: ["https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 52,
    title: "What Founders Get Wrong About Building AI Features",
    category: "Technology",
    excerpt: "The mistake usually isn't the model — it's building a feature nobody asked for.",
    content: "Notes from product teams on where AI genuinely improves an experience, and where it's just decoration.",
    author: "Nikhil Bhatia",
    company: "Park Hyatt",
    publisher: "IHN",
    date: "August 10, 2026",
    likes: 119,
    comments: 13,
    images: ["https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 53,
    title: "The Infrastructure Behind India's Digital Payments Boom",
    category: "Technology",
    excerpt: "A look at the plumbing that made instant payments an everyday habit.",
    content: "How shared public infrastructure, not any single company, became the backbone of the shift to digital payments.",
    author: "Simran Kaur",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "August 5, 2026",
    likes: 141,
    comments: 17,
    images: ["https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 54,
    title: "Why Dashboards Are Getting Simpler, Not Smarter",
    category: "Technology",
    excerpt: "The best business tools are quietly removing features, not adding them.",
    content: "A look at why product teams are trading complexity for clarity in the tools people use every day.",
    author: "Nikhil Bhatia",
    company: "Park Hyatt",
    publisher: "IHN",
    date: "July 31, 2026",
    likes: 112,
    comments: 10,
    images: ["https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },

  // ---------------- GENERAL (9) ----------------
  {
    id: 55,
    title: "The Stories That Stay With Us",
    category: "General",
    excerpt: "Not every story fits neatly into a category — some are just worth telling.",
    content: "A collection of small, memorable moments shared by readers over the past few months. Every week, readers send us fragments — a single interaction, a chance meeting, a quiet evening that somehow stuck.\n\nThis piece gathers a few of the ones we couldn't stop thinking about. There was the engineer who waited forty minutes at a railway station for a stranger he'd only met on the platform ten minutes before, just to make sure she found the right coach.\n\nThere was the old couple who ate at the same corner café every Tuesday for thirty years, and the waiter who finally worked up the courage to ask why — their answer: it was the day they'd met, and they never wanted to waste it indoors.\n\nThere was also the hotel doorman who, on his last shift before retirement, was greeted by more than seventy former guests he didn't remember by name but who clearly remembered his.\n\nNone of these stories have a moral. That's partly why they stay with us. They're not teaching anything — they're simply evidence that people are paying attention to each other more than the news lets on.",
    author: "IHN Editorial",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "September 6, 2026",
    likes: 115,
    comments: 25,
    images: [
      "https://images.unsplash.com/photo-1519638399535-1b036603ac77?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1503437313881-503a91226402?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: true,
  },
  {
    id: 56,
    title: "Why Some Everyday Experiences Feel Extraordinary",
    category: "General",
    excerpt: "A closer look at the ordinary moments that end up mattering the most.",
    content: "On noticing — and why the most memorable parts of a week are rarely the ones we planned. We plan weddings, promotions and vacations, and too often those are the memory anchors we expect.\n\nBut when people actually sit down and list the moments they'd preserve, the answers almost never match the calendar. It's the unexpected rainstorm that turned a walk into a dash for a tea stall, shared with a stranger. It's the late conversation that ran past midnight because neither person wanted to leave.\n\nIt's the view from a kitchen window at dusk on a completely ordinary Tuesday. Psychologists call this the availability effect working against us — the big moments stay scheduled, while the small ones slip past unnoticed precisely because nobody wrote them down.\n\nThe fix isn't dramatic. It's a version of noticing: walking home a different way, taking the slow route, letting a conversation run long. The extraordinary isn't hiding in the spectacular. It's hiding in plain sight, in the everyday, waiting for someone to stop rushing.\n\nThe memorable week isn't the busiest one. It's the one where a few ordinary moments were allowed to feel big enough to matter.",
    author: "Rohan Sethi",
    company: "Hilton India",
    publisher: "IHN",
    date: "September 1, 2026",
    likes: 154,
    comments: 19,
    images: [
      "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1500534623283-312aade485b7?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 57,
    title: "What Community Actually Means in a Digital Age",
    category: "General",
    excerpt: "The word gets used constantly — this is an attempt to define it more carefully.",
    content: "A reflection on belonging, distance, and what still makes a community feel real online. The word community is doing too much work these days. An email list is called a community. A brand's comment section is called a community.\n\nSomewhere in that dilution, the actual thing — the thing that gives people roots — started to disappear. And yet, watch closely and it hasn't. It shows up in the WhatsApp group that has been active daily for five years, where members actually show up for each other's weddings.\n\nIt shows up in the niche forum where a stranger's question about a failing business gets a twenty-paragraph answer free of charge. What makes these communities real where others are fake is not the platform — it's the accountabilities.\n\nPeople return. They remember. They carry obligations beyond the moment of posting. That's why the most successful online communities feel oddly old-fashioned: they run on reciprocity, patience and a shared sense of stakes, not on engagement metrics.\n\nThe digital age didn't kill community. It just made it optional, which means the ones that survive are the ones people genuinely choose — and choosing, it turns out, is exactly what makes something feel like home.",
    author: "IHN Editorial",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "August 27, 2026",
    likes: 142,
    comments: 17,
    images: [
      "https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=1200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=1200&q=80&auto=format&fit=crop",
    ],
    isEditorsPick: false,
  },
  {
    id: 58,
    title: "The Conversations Worth Having Twice",
    category: "General",
    excerpt: "Some ideas only make sense the second time you sit with them.",
    content: "On revisiting old conversations with new context, and what usually changes.",
    author: "Rohan Sethi",
    company: "Hilton India",
    publisher: "IHN",
    date: "August 22, 2026",
    likes: 121,
    comments: 14,
    images: ["https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 59,
    title: "How a Small Idea Turned Into a Lasting Tradition",
    category: "General",
    excerpt: "A short story about how habits quietly become identity.",
    content: "One family's annual gathering, and what it reveals about how traditions actually form.",
    author: "IHN Editorial",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "August 17, 2026",
    likes: 133,
    comments: 15,
    images: ["https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 60,
    title: "The People Who Quietly Hold Communities Together",
    category: "General",
    isEditorsPickBadge: true,
    excerpt: "Rarely the loudest voices, always the most essential ones.",
    content: "A tribute to the organizers, connectors and quiet contributors who rarely get recognition.",
    author: "Rohan Sethi",
    company: "Hilton India",
    publisher: "IHN",
    date: "August 12, 2026",
    likes: 268,
    comments: 20,
    images: ["https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 61,
    title: "Notes on Slowing Down in a Fast Year",
    category: "General",
    excerpt: "A short reflection written somewhere between two deadlines.",
    content: "Nothing conclusive here — just an honest account of trying to slow down without falling behind.",
    author: "IHN Editorial",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "August 7, 2026",
    likes: 109,
    comments: 11,
    images: ["https://images.unsplash.com/photo-1503437313881-503a91226402?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 62,
    title: "What We Learned From Our Readers This Year",
    category: "General",
    excerpt: "A look back at the stories, comments and conversations that shaped this year.",
    content: "A short recap of the themes readers kept returning to, and where the community goes from here.",
    author: "IHN Editorial",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "August 1, 2026",
    likes: 332,
    comments: 23,
    images: ["https://images.unsplash.com/photo-1454496522488-7a8e488e8606?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
    isEditorsPickBadge: true,
    isExpertVoice: true,
  },
  {
    id: 63,
    title: "A Few Things We're Thinking About Right Now",
    category: "General",
    excerpt: "Not quite a trend piece — just a handful of ideas currently on the editorial team's mind.",
    content: "An informal round-up of themes we expect to write more about in the coming months.",
    author: "IHN Editorial",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "July 27, 2026",
    likes: 98,
    comments: 9,
    images: ["https://images.unsplash.com/photo-1500534623283-312aade485b7?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 64,
    title: "Why Every Hotel Is Becoming a Tech Company",
    category: "Technology",
    excerpt: "From smart rooms to predictive maintenance, hospitality is rewriting its playbook.",
    content: "A look at how hotels are embedding technology into every touchpoint of the guest journey.",
    author: "Nikhil Bhatia",
    company: "Park Hyatt",
    publisher: "IHN",
    date: "July 20, 2026",
    likes: 124,
    comments: 13,
    images: ["https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 65,
    title: "The Rise of AI Concierges in Boutique Hotels",
    excerpt: "Small properties are adopting AI to offer personalised service at scale.",
    content: "How independent hotels are using conversational AI to match the service quality of luxury chains.",
    category: "Technology",
    author: "Devika Rao",
    company: "The Oberoi Group",
    publisher: "IHN",
    date: "July 12, 2026",
    likes: 108,
    comments: 9,
    images: ["https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 66,
    title: "How Wellness Travel Is Reshaping Luxury Resorts",
    excerpt: "Guests want more than a spa menu — they want a full reset.",
    content: "Inside the resorts designing holistic wellness programmes that go far beyond massages.",
    category: "Lifestyle",
    author: "Tara Sen",
    company: "Pullman Gurgaon",
    publisher: "IHN",
    date: "July 18, 2026",
    likes: 167,
    comments: 16,
    images: ["https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 67,
    title: "The Slow Living Movement and What It Means for Hospitality",
    category: "Lifestyle",
    excerpt: "A growing segment of travellers is choosing slowness over spectacle.",
    content: "How the slow living trend is influencing everything from resort design to F&B programming.",
    author: "Meera Kapoor",
    company: "Hyatt Regency",
    publisher: "IHN",
    date: "July 8, 2026",
    likes: 143,
    comments: 11,
    images: ["https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 68,
    title: "Why Digital Detox Weekends Are Booking Out Faster Than Ever",
    category: "Lifestyle",
    excerpt: "Disconnecting is no longer a luxury — it's the luxury.",
    content: "Properties offering screen-free stays report record demand, especially among young professionals.",
    author: "Sana Iqbal",
    company: "Sheraton Grand",
    publisher: "IHN",
    date: "June 30, 2026",
    likes: 156,
    comments: 14,
    images: ["https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 69,
    title: "Why Regional Indian Cuisine Is Finally Getting Its Own Fine-Dining Moment",
    category: "Food",
    excerpt: "Chefs are turning home cooking from across India into tasting menus with real depth.",
    content: "From coastal seafood to Himalayan stews, regional kitchens are moving from hotel banquets to destination restaurants.",
    author: "Ananya Bose",
    company: "Grand Hyatt Mumbai",
    publisher: "IHN",
    date: "September 10, 2026",
    likes: 182,
    comments: 18,
    images: ["https://images.unsplash.com/photo-1512058564366-18510be2db19?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 70,
    title: "The Hidden Costs Behind Delhi's Restaurant Boom",
    category: "Food",
    excerpt: "Opening a restaurant in the capital has never been easier — or harder to make work.",
    content: "Rent, ingredients and staffing ate into margins for the city's newest batch of independent kitchens.",
    author: "Karan Vij",
    company: "Marriott India",
    publisher: "IHN",
    date: "September 5, 2026",
    likes: 134,
    comments: 11,
    images: ["https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 71,
    title: "A Chef's Guide to Cooking With the Seasons in India",
    category: "Food",
    excerpt: "What produce actually gets better at each point in the year across Indian markets.",
    content: "A practical seasonal calendar from chefs who shop the morning markets every single day.",
    author: "Karan Vij",
    company: "Marriott India",
    publisher: "IHN",
    date: "August 28, 2026",
    likes: 146,
    comments: 13,
    images: ["https://images.unsplash.com/photo-1606787366850-de6330128bfc?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 72,
    title: "The Konkan Coast Road Trip Everyone Is Talking About",
    category: "Travel",
    excerpt: "A stretch of highway that belongs on every Indian traveller's shortlist.",
    content: "Fort towns, cashew farms and one very good sea-facing guesthouse along a coast that rewards slow travel.",
    author: "Naina Chopra",
    company: "Novotel Delhi",
    publisher: "IHN",
    date: "September 9, 2026",
    likes: 231,
    comments: 21,
    images: ["https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: true,
  },
  {
    id: 73,
    title: "Why Indian Railways Is the Best Way to See the Country",
    category: "Travel",
    excerpt: "Planes get you there; trains show you the country in between.",
    content: "An argument for trading a 90-minute flight for a 12-hour rail journey through changing landscapes.",
    author: "Rohan Sethi",
    company: "Hilton India",
    publisher: "IHN",
    date: "September 3, 2026",
    likes: 364,
    comments: 26,
    images: ["https://images.unsplash.com/photo-1474487548417-781cb71495f3?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 74,
    title: "The Rising Popularity of Solo Travel in India",
    category: "Travel",
    excerpt: "More Indians are travelling alone — and the industry is slowly catching up.",
    content: "What solo travellers want, from single-occupancy pricing to hostels that actually feel social.",
    author: "Tara Sen",
    company: "Pullman Gurgaon",
    publisher: "IHN",
    date: "August 25, 2026",
    likes: 198,
    comments: 19,
    images: ["https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 75,
    title: "What Small Businesses Get Wrong About Branding",
    category: "Business",
    excerpt: "A logo isn't a brand — and confusing the two is expensive.",
    content: "Why the strongest small businesses treat branding as behaviour, not decoration.",
    author: "Vikram Anand",
    company: "Vivanta Hotels",
    publisher: "IHN",
    date: "September 8, 2026",
    likes: 172,
    comments: 16,
    images: ["https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 76,
    title: "How Indian Hotels Are Rethinking the Family Suite",
    category: "Business",
    excerpt: "Demand is shifting the economics of the traditional hotel room.",
    content: "Interconnecting doors, kitchenettes and flexible check-in are becoming standard as travel habits change.",
    author: "Nikhil Bhatia",
    company: "Park Hyatt",
    publisher: "IHN",
    date: "August 30, 2026",
    likes: 149,
    comments: 12,
    images: ["https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 77,
    title: "The Third-Party Booking Trap Every Hotel Owner Should Know",
    category: "Business",
    excerpt: "OTAs bring the volume. They also take a cut that quietly compounds.",
    content: "A simple model for when direct booking incentives are worth the margin they cost you.",
    author: "Meera Kapoor",
    company: "Hyatt Regency",
    publisher: "IHN",
    date: "August 22, 2026",
    likes: 158,
    comments: 14,
    images: ["https://images.unsplash.com/photo-1567958451986-2de427a4a0be?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 78,
    title: "The Quiet Luxury Trend Coming to Indian Weddings",
    category: "Fashion",
    excerpt: "Understated bridal wear is gaining ground against heavy embellishment.",
    content: "Designers report a shift toward quieter silhouettes, softer tones and fabric-first garments.",
    author: "Divya Malhotra",
    company: "ITC Hotels",
    publisher: "IHN",
    date: "September 6, 2026",
    likes: 191,
    comments: 17,
    images: ["https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 79,
    title: "How Indian Textile Crafts Are Finding a New Global Audience",
    category: "Fashion",
    excerpt: "Block print, ikat and handloom are moving from craft fairs to international collections.",
    content: "The cooperatives and contemporary labels carrying traditional techniques into new markets.",
    author: "Naina Chopra",
    company: "Novotel Delhi",
    publisher: "IHN",
    date: "August 27, 2026",
    likes: 167,
    comments: 15,
    images: ["https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 80,
    title: "The Styling Rule That Saves Every Indian Wardrobe",
    category: "Fashion",
    excerpt: "One habit separates a wardrobe that works from one that sits untouched.",
    content: "Why building around a single colour story makes getting dressed dramatically easier.",
    author: "Ishita Rao",
    company: "Radisson Blu",
    publisher: "IHN",
    date: "August 18, 2026",
    likes: 143,
    comments: 10,
    images: ["https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 81,
    title: "How Hotels Are Using Data to Personalise Your Stay",
    category: "Technology",
    excerpt: "The guest profile has quietly become the most valuable asset in hospitality tech.",
    content: "From check-in preferences to room temperature, the smart hotel is learning as fast as you travel.",
    author: "Arjun Malhotra",
    company: "Taj Hotels",
    publisher: "IHN",
    date: "July 25, 2026",
    likes: 119,
    comments: 9,
    images: ["https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 82,
    title: "On the Small Joys You Don't Plan For",
    category: "General",
    excerpt: "The day is full of unplanned moments that are quietly the best part.",
    content: "A reminder to leave space in the schedule for the things that make it worth having a schedule.",
    author: "Rhea Mathur",
    company: "JW Marriott",
    publisher: "IHN",
    date: "July 21, 2026",
    likes: 127,
    comments: 10,
    images: ["https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 83,
    title: "What We Mean When We Say 'Back to Basics'",
    category: "General",
    excerpt: "The phrase gets used everywhere. This is what it should actually mean.",
    content: "On stripping back to the fundamentals that still matter — and the ones we never needed.",
    author: "Ishaan Verma",
    company: "Leela Palaces",
    publisher: "IHN",
    date: "July 15, 2026",
    likes: 115,
    comments: 8,
    images: ["https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 84,
    title: "A Letter to The Reader Who Stays",
    category: "General",
    excerpt: "A short, honest note to the people who keep coming back.",
    content: "What the readership of this publication means to the people who make it every week.",
    author: "Editorial Team",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "July 9, 2026",
    likes: 139,
    comments: 12,
    images: ["https://images.unsplash.com/photo-1519834785169-98be25ec3f84?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },

  // ---------------- PLACEHOLDER CARDS (9..12 per category) ----------------
  // These extra cards have no article yet; they are non-clickable until CMS
  // content is wired in via the backend.
  {
    id: 85,
    title: "The Fermented Foods Coming Back to Indian Kitchens",
    category: "Food",
    excerpt: "Pickles, kanji, and dosa batter are enjoying a quiet modern revival in home kitchens across the country.",
    content: "Coming soon — full article under production.",
    author: "Ishita Rao",
    company: "Radisson Blu",
    publisher: "IHN",
    date: "August 12, 2026",
    likes: 98,
    comments: 8,
    images: ["https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 87,
    title: "Why Regional Dinner Kitchens Are the New Fine Dining",
    category: "Food",
    excerpt: "The most exciting plates in India right now are coming from home kitchens, not tasting menus.",
    content: "Coming soon — full article under production.",
    author: "Karan Vij",
    company: "Marriott India",
    publisher: "IHN",
    date: "July 28, 2026",
    likes: 112,
    comments: 9,
    images: ["https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 88,
    title: "One Week by Boat Through the Kerala Backwaters",
    category: "Travel",
    excerpt: "A houseboat journey that moves at the pace of the water and never feels slow.",
    content: "Coming soon — full article under production.",
    author: "Rhea Mathur",
    company: "JW Marriott",
    publisher: "IHN",
    date: "July 20, 2026",
    likes: 134,
    comments: 11,
    images: ["https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 89,
    title: "The Temple Towns Worth a Detour on Any South India Route",
    category: "Travel",
    excerpt: "A handful of sacred towns that reward the unplanned stop with the best of the region.",
    content: "Coming soon — full article under production.",
    author: "Naina Chopra",
    company: "Novotel Delhi",
    publisher: "IHN",
    date: "July 14, 2026",
    likes: 121,
    comments: 10,
    images: ["https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 90,
    title: "Chasing the First Light in the Aravalli Hills",
    category: "Travel",
    excerpt: "What you see before the world wakes up along one of India's oldest mountain ranges.",
    content: "Coming soon — full article under production.",
    author: "Karan Vij",
    company: "Marriott India",
    publisher: "IHN",
    date: "July 8, 2026",
    likes: 116,
    comments: 7,
    images: ["https://images.unsplash.com/photo-1504198266287-1659872e6590?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 91,
    title: "How a Small Boutique Hotel Built a Brand Without a Marketing Team",
    category: "Business",
    excerpt: "Word of mouth, a distinctive point of view, and a refusal to look like everyone else.",
    content: "Coming soon — full article under production.",
    author: "Sana Iqbal",
    company: "Sheraton Grand",
    publisher: "IHN",
    date: "July 26, 2026",
    likes: 141,
    comments: 12,
    images: ["https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 92,
    title: "The Unwritten Rules of Hospitality Negotiation",
    category: "Business",
    excerpt: "The deal is won long before the contract, in language, timing and trust.",
    content: "Coming soon — full article under production.",
    author: "Vikram Anand",
    company: "Vivanta Hotels",
    publisher: "IHN",
    date: "July 19, 2026",
    likes: 132,
    comments: 9,
    images: ["https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 93,
    title: "What Opening a Second Location Teaches a Family Business",
    category: "Business",
    excerpt: "The lessons that only appear when a proven model has to be rebuilt somewhere new.",
    content: "Coming soon — full article under production.",
    author: "Priya Nair",
    company: "IHN India",
    publisher: "IHN",
    date: "July 12, 2026",
    likes: 128,
    comments: 8,
    images: ["https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 94,
    title: "The Art of the Afternoon Reset",
    category: "Lifestyle",
    excerpt: "Fifteen minutes to reclaim the second half of the day from the first.",
    content: "Coming soon — full article under production.",
    author: "Divya Malhotra",
    company: "ITC Hotels",
    publisher: "IHN",
    date: "July 22, 2026",
    likes: 138,
    comments: 10,
    images: ["https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 95,
    title: "Why Boredom Is the Most Underrated Productivity Tool",
    category: "Lifestyle",
    excerpt: "The ideas that arrive when the mind is left with nothing to do are rarely the ones you predict.",
    content: "Coming soon — full article under production.",
    author: "Ishaan Verma",
    company: "Leela Palaces",
    publisher: "IHN",
    date: "July 16, 2026",
    likes: 149,
    comments: 13,
    images: ["https://images.unsplash.com/photo-1500534623283-312aade485b7?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 96,
    title: "Building Evenings That Don't End With a Screen",
    category: "Lifestyle",
    excerpt: "Small swaps in the last hour of the day that change how the night feels.",
    content: "Coming soon — full article under production.",
    author: "Ananya Bose",
    company: "Grand Hyatt Mumbai",
    publisher: "IHN",
    date: "July 10, 2026",
    likes: 118,
    comments: 9,
    images: ["https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 97,
    title: "How to Shop for Clothes That Outlast Three Seasons",
    category: "Fashion",
    excerpt: "The fabric, stitching and cut signals that separate a keeper from a quick regret.",
    content: "Coming soon — full article under production.",
    author: "Devika Rao",
    company: "The Oberoi Group",
    publisher: "IHN",
    date: "July 24, 2026",
    likes: 156,
    comments: 12,
    images: ["https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 98,
    title: "The Street Style of Mumbai's Train Ladies",
    category: "Fashion",
    excerpt: "The most inventive fashion in the country is worn in a crowd, not on a runway.",
    content: "Coming soon — full article under production.",
    author: "Tara Sen",
    company: "Pullman Gurgaon",
    publisher: "IHN",
    date: "July 17, 2026",
    likes: 141,
    comments: 10,
    images: ["https://images.unsplash.com/photo-1520975954732-35dd22299614?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 99,
    title: "When Denim Replaced the Formal Jacket in Indian Offices",
    category: "Fashion",
    excerpt: "How workplace dress codes loosened, and what took the place of the blazer.",
    content: "Coming soon — full article under production.",
    author: "Naina Chopra",
    company: "Novotel Delhi",
    publisher: "IHN",
    date: "July 5, 2026",
    likes: 129,
    comments: 7,
    images: ["https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 100,
    title: "The Small Apps Quietly Running India's Best Hotels",
    category: "Technology",
    excerpt: "Behind every smooth check-in is a software stack nobody ever sees.",
    content: "Coming soon — full article under production.",
    author: "Simran Kaur",
    company: "ABC Hospitality",
    publisher: "IHN",
    date: "July 18, 2026",
    likes: 137,
    comments: 9,
    images: ["https://images.unsplash.com/photo-1551650975-87deedd944c3?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 101,
    title: "Why Offline-First Software Is Winning in Tier-2 India",
    category: "Technology",
    excerpt: "The best products for growing cities assume the network will fail and work anyway.",
    content: "Coming soon — full article under production.",
    author: "Nikhil Bhatia",
    company: "Park Hyatt",
    publisher: "IHN",
    date: "July 11, 2026",
    likes: 124,
    comments: 8,
    images: ["https://images.unsplash.com/photo-1481487196290-c152efe083f5?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 102,
    title: "The Sensor Tricks That Cut Hotel Energy Bills in Half",
    category: "Technology",
    excerpt: "Occupancy sensing and smart climate zones are quietly rewriting hotel utility costs.",
    content: "Coming soon — full article under production.",
    author: "Arjun Malhotra",
    company: "Taj Hotels",
    publisher: "IHN",
    date: "July 3, 2026",
    likes: 119,
    comments: 6,
    images: ["https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 103,
    title: "The Unexpected Kindness Files, Volume Twelve",
    category: "General",
    excerpt: "A running collection of small deeds readers spotted and sent in this month.",
    content: "Coming soon — full article under production.",
    author: "IHN Editorial",
    company: "IHN Editorial",
    publisher: "IHN",
    date: "July 6, 2026",
    likes: 178,
    comments: 16,
    images: ["https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 104,
    title: "A Field Guide to Good Questions",
    category: "General",
    excerpt: "The right question does more work than the right answer, and it's a skill worth building.",
    content: "Coming soon — full article under production.",
    author: "Rohan Sethi",
    company: "Hilton India",
    publisher: "IHN",
    date: "June 28, 2026",
    likes: 145,
    comments: 12,
    images: ["https://images.unsplash.com/photo-1543269865-cbf427effbad?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
  {
    id: 105,
    title: "Notes From a Long Table of Strangers",
    category: "General",
    excerpt: "What happens when twelve people who have never met agree to share one long dinner.",
    content: "Coming soon — full article under production.",
    author: "Rhea Mathur",
    company: "JW Marriott",
    publisher: "IHN",
    date: "June 21, 2026",
    likes: 131,
    comments: 11,
    images: ["https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=1200&q=80&auto=format&fit=crop"],
    isEditorsPick: false,
  },
];

// The owner's "My Posts" pills (My / Archived / Saved / Liked) on the Published
// listing are all driven live by the shared blog stores (archive, save, like),
// so no hardcoded seed IDs live here anymore.

/* ============================================================================
   ARTICLE FALLBACK + PAGE-LEVEL HELPERS
   ARTICLE is the structured single article used as the BlogArticlePage
   fallback. Cards on the Blogs page navigate to /blog/<slug> and
   `resolveArticle` finds the matching entry (BLOG_POSTS first, then BLOGS)
   and derives its rich content + prev/next navigation.
   ============================================================================ */

export const ARTICLE = {
  id: 12,
  slug: "the-quiet-power-of-a-ten-minute-walk-after-meals",
  category: "Nutrition",
  title: "The Quiet Power of a Ten-Minute Walk After Meals",
  excerpt:
    "A small, unglamorous habit is quietly backed by some of the most consistent evidence in metabolic health — no equipment, no subscription, no forty-minute time commitment. Here's what a short walk after eating actually does inside the body, and why timing matters more than intensity.",
  author: "Lauren Whitfield",
  publisher: "IHN Editorial",
  date: "2026-09-09",
  comments: 46,
  likes: 312,
  images: [
    "https://images.unsplash.com/photo-1502904550040-7534597429ae?w=1400&q=80",
    "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1400&q=80",
    "https://images.unsplash.com/photo-1526401485004-46910ecc8e51?w=1400&q=80",
    "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=1400&q=80",
  ],
  content: [
    {
      type: "paragraph",
      text: "Most nutrition advice arrives with a price tag attached — a supplement, a subscription, a piece of equipment that ends up folded in a closet by March. So it's worth pausing on a habit that costs nothing and takes less time than scrolling through a single social feed: walking for about ten minutes after you eat.",
    },
    {
      type: "paragraph",
      text: "It sounds almost too small to matter. But across a growing body of research, this particular window — the hour or so right after a meal — turns out to be one of the more responsive moments in the body's daily rhythm. What you do with it has an outsized effect on how that meal is processed.",
    },
    {
      type: "heading",
      text: "Why timing beats intensity",
    },
    {
      type: "paragraph",
      text: "When you eat, glucose from your meal enters the bloodstream and your muscles are the single largest consumer of that glucose. Muscle contraction — even gentle, low-effort contraction — pulls glucose out of the blood and into muscle tissue without requiring much insulin to do the work. A short walk activates exactly that pathway, right when it's most useful.",
    },
    {
      type: "paragraph",
      text: "This is why several studies comparing walking before meals, after meals, or not at all have landed on the same conclusion: a walk taken in the thirty to sixty minutes following a meal produces a noticeably flatter post-meal glucose curve than the same walk taken at some unrelated point in the day. The effect isn't about burning calories. It's about timing a very ordinary movement to match a very specific metabolic window.",
    },
    {
      type: "image",
      imageIndex: 1,
      alt: "A person walking along a tree-lined path in soft afternoon light",
    },
    {
      type: "heading",
      text: "What ten minutes actually changes",
    },
    {
      type: "paragraph",
      text: "Researchers studying this effect have repeatedly found that even short walks — as brief as two to five minutes, and more reliably at ten — meaningfully reduce the glucose spike that follows eating, compared with remaining seated. Longer walks help more, but the curve isn't linear: the first ten minutes appear to do a disproportionate share of the work.",
    },
    {
      type: "quote",
      text: "The body doesn't need a workout after dinner. It needs a signal — and a slow walk to the end of the block is often signal enough.",
    },
    {
      type: "paragraph",
      text: "For people managing blood sugar day to day, that flatter curve matters beyond the hour it's measured in. Repeated glucose spikes, meal after meal, are linked over time to insulin resistance, energy crashes, and increased cardiometabolic risk. A habit that consistently softens those spikes is doing quiet, compounding work in the background.",
    },
    {
      type: "heading",
      text: "Making it sustainable, not another rule",
    },
    {
      type: "paragraph",
      text: "The habits that last tend to be the ones that ask the least of us. A ten-minute walk doesn't require a change of clothes, a gym membership, or a block of free time carved out of an already full day. It can happen in a hallway, around a parking lot, or up and down a single flight of stairs.",
    },
    {
      type: "image",
      imageIndex: 2,
      alt: "Close-up of walking shoes on a paved outdoor path",
    },
    {
      type: "paragraph",
      text: "It also stacks easily onto things people are already doing — taking a call standing up and pacing, walking a dog that needed walking anyway, or using the ten minutes after dinner to step outside before the evening settles in. The habit works precisely because it asks so little.",
    },
    {
      type: "paragraph",
      text: "None of this is a substitute for the other fundamentals — balanced meals, adequate protein, regular activity across the week. But as a low-cost addition layered on top of those fundamentals, it's rare to find something this well-supported that requires this little.",
    },
    {
      type: "image",
      imageIndex: 3,
      alt: "Evening skyline seen from a quiet walking trail",
    },
    {
      type: "heading",
      text: "The takeaway",
    },
    {
      type: "paragraph",
      text: "You don't need to overhaul how you eat to get some of the benefit of eating well. Sometimes the highest-leverage change is simply standing up ten minutes after the last bite and walking somewhere — anywhere — before you sit back down.",
    },
  ],
  previousArticle: {
    slug: "the-art-of-creating-a-better-breakfast",
    title: "The Art of Creating a Better Breakfast",
  },
  nextArticle: {
    slug: "a-weekend-in-the-hills",
    title: "A Weekend in the Hills",
  },
};

// Converts a blog title into a URL-safe slug ("My Title!" -> "my-title").
export function titleToSlug(title) {
  return String(title || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Finds the matching article for a :slug route param across both shared
// datasets (BLOG_POSTS first, then BLOGS). Returns a normalized object with
// slug + previous/next navigation derived from the source list order.
// Falls back to the structured sample ARTICLE when nothing matches.
export function resolveArticle(slug) {
  const normalizedSlug = String(slug || "").toLowerCase();

  const lists = [BLOG_POSTS, BLOGS];

  for (const list of lists) {
    const index = list.findIndex(
      (blog) =>
        (blog.slug ? String(blog.slug).toLowerCase() : titleToSlug(blog.title)) ===
        normalizedSlug
    );

    if (index === -1) continue;

    const current = list[index];
    const prev = list[index - 1];
    const next = list[index + 1];

    return {
      ...current,
      slug: current.slug || normalizedSlug,
      previousArticle: prev
        ? { slug: titleToSlug(prev.title), title: prev.title }
        : null,
      nextArticle: next
        ? { slug: titleToSlug(next.title), title: next.title }
        : null,
    };
  }

  return ARTICLE;
}
